import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface HtmlContentProps {
    content: string;
    title: string;
    onNext: () => void;
    onPrev: () => void;
    hasPrev: boolean;
}

const HtmlContent: React.FC<HtmlContentProps> = ({ content, title, onNext, onPrev, hasPrev }) => {
    return (
        <div className="w-full h-full bg-black overflow-y-auto text-white">
            {/* Añadimos pt-24 (padding-top) para dejar espacio a la barra superior fija */}
            <div className="max-w-4xl mx-auto px-6 pt-24 pb-12 md:pb-20">
                {/* Título de la lección - Visible en el cuerpo también para contexto al scrollear */}
                <h1 className="text-3xl md:text-4xl font-bold mb-8 text-indigo-400 border-b border-white/10 pb-6">
                    {title}
                </h1>

                {/* Contenedor del contenido HTML inyectado */}
                <div
                    className="prose prose-invert max-w-none 
            [&>p]:mb-4 [&>p]:leading-relaxed [&>p]:text-gray-300
            [&>h1]:text-2xl [&>h1]:font-bold [&>h1]:mt-8 [&>h1]:mb-4 [&>h1]:text-white
            [&>h2]:text-xl [&>h2]:font-semibold [&>h2]:mt-6 [&>h2]:mb-3 [&>h2]:text-white
            [&>ul]:list-disc [&>ul]:pl-5 [&>ul]:mb-4
            [&>img]:rounded-lg [&>img]:my-6 [&>img]:max-w-full [&>img]:h-auto [&>img]:border [&>img]:border-white/10
            [&>hr]:border-white/10 [&>hr]:my-8
            [&>a]:text-indigo-400 [&>a]:underline hover:[&>a]:text-indigo-300"
                    dangerouslySetInnerHTML={{ __html: content }}
                />

                {/* Botones de navegación al final */}
                <div className="flex items-center justify-between mt-16 pt-8 border-t border-white/10">
                    <button
                        onClick={onPrev}
                        disabled={!hasPrev}
                        className="flex items-center gap-2 px-6 py-3 rounded-full bg-white/5 border border-white/10 text-white hover:bg-white/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed group"
                    >
                        <ChevronLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
                        <span className="font-medium">Anterior</span>
                    </button>

                    <button
                        onClick={onNext}
                        className="flex items-center gap-2 px-6 py-3 rounded-full bg-indigo-600 text-white hover:bg-indigo-500 transition-colors group shadow-lg shadow-indigo-900/20"
                    >
                        <span className="font-medium">Siguiente</span>
                        <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HtmlContent;
